import ReactDOM from 'react-dom';
import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import axios from 'axios';
import { Provider } from "@byhuz/huz-ui-state";
//import UseAuth from 'components/Common/UseAuth';
import SecuredContainer from "components/Common/SecuredContainer";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.withCredentials = true;

export default function App(props) {  

    const initialize=()=>{  
      /*
          axios.get('userinfo')
            .then(res=>{
              console.log("index.js",res);
              if (parseInt(res.data.code)===400) {
                Store.dispatch(Action.update("loggedIn", false));
                Store.dispatch(Action.update("user", res.data.payload));
                return;
              }

              if (parseInt(res.data.code)===404) {            
                Store.dispatch(Action.update("loggedIn", false));
                return;
              }

              if (parseInt(res.data.code)===200) {            
                Store.dispatch(Action.update("loggedIn", true));
                Store.dispatch(Action.update("user", res.data.payload));
              }
            })
            .catch(err=>{
              console.log(err);
            })  
        */
    } 

    React.useEffect(() => {
    
      initialize();

      // MOUNTED
      return () => {
        // UNMOUNTED
      }
    }, []);
  
      return(        
          <BrowserRouter>
            <Switch>
              {/* add routes with layouts */}              
              <Route path="/admin" component={() => 
                <SecuredContainer>
                    <Admin/>
                </SecuredContainer>} />            
              <Route path="/auth" component={() => <Auth/>} />
              {/* add redirect for first page */}
              <Redirect from="*" to="/auth" />
            </Switch>
          </BrowserRouter>        
      );
  }

// Publish Pages
ReactDOM.render(<Provider><App/></Provider>,document.getElementById("root"));